import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyPromise } from '../../interceptors/myPromise.service';

const PROCEDURES_API = `${environment.baseEndpoint}/procedures`;

@Injectable({
  providedIn: 'root',
})
export class ProcedureTwoService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }

  signPolicy(stationId, signPolicy) {
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/1/signPolitics`, signPolicy));
  }

  getEnvironmentalImpactsTable(stationId, activity) {
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsTable/${activity}`));
  }

  getEnvironmentalImpactsControlMonitoring(stationId) {
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsControlMonitoring`));
  }

  environmentalImpactsTable(stationId, enviromentalImpact, activity) {
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsTable/${activity}`, enviromentalImpact));
  }

  updateEnvironmentalImpactsTable(stationId, enviromentalImpact, activity) {
    return this.myPromise.to(this.http.put(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsTable/${activity}`, enviromentalImpact));
  }

  saveEnvironmentalImpactsEvaluation(stationId, evaluation) {
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsEvaluation`, { evaluation }));
  }

  saveEnvironmentalImpactsControlMonitoring(stationId, activity, evaluation) {
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsControlMonitoring/${activity}`, evaluation));
  }

  updateEnvironmentalImpactsEvaluation(stationId, evaluation) {
    return this.myPromise.to(this.http.put(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsEvaluation`, evaluation));
  }

  getEnvironmentalImpactsEvaluation(stationId) {
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/2/environmentalImpactsEvaluation`));
  }

}
